import React, {useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from "../../context/auth";


const PreAuthRouteWithLayout = props => {
    const { layout: Layout, component: Component, no_redirect, ...rest } = props;
    const { authToken, authUser } = useAuth();

    return (
        <Route
            {...rest}
            render={matchProps => {
                // Always let the page render if an otp_token is present —
                // this is a Google OAuth callback that needs to exchange the
                // token regardless of the current auth state (e.g. guest session).
                const params = new URLSearchParams(matchProps.location.search);
                const hasOtpToken = !!params.get('otp_token');

                return authToken && authUser && !no_redirect && !hasOtpToken ? (
                    <Redirect
                        to={{ pathname: "/dq_pro/home" }}
                    />
                ) : (
                    <Layout>
                        <Component {...matchProps} />
                    </Layout>
                );
            }}
        />
    );

};

export default PreAuthRouteWithLayout;
